/**
 * Detects whether an unknown thrown value is a "chunk load" / "dynamic import
 * failed" error that occurs when a browser tries to fetch a hashed JS chunk
 * that was deleted by a new deployment.
 *
 * Known message patterns (cross-browser):
 *  - Chrome/Edge : "Failed to fetch dynamically imported module: ..."
 *  - Firefox     : "error loading dynamically imported module"
 *  - Safari      : "Importing a module script failed."
 *  - Webpack     : "Loading chunk <n> failed."
 *  - Vite/Rollup : "Unable to preload CSS for ..."  (less common but included)
 */

const CHUNK_ERROR_PATTERNS: RegExp[] = [
  /Failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /Importing a module script failed/i,
  /Loading chunk \d+ failed/i,
  /Unable to preload CSS for/i,
  /ChunkLoadError/i,
];

export function isChunkLoadError(error: unknown): boolean {
  if (!error) return false;

  const message =
    error instanceof Error
      ? `${error.name}: ${error.message}`
      : String(error);

  return CHUNK_ERROR_PATTERNS.some((pattern) => pattern.test(message));
}

/**
 * sessionStorage key used to prevent infinite reload loops.
 * Both ErrorBoundary and the global unhandledrejection handler share this key.
 */
export const CHUNK_RELOAD_KEY = "eco_chunk_reload_attempted";